module.exports = __webpack_public_path__ + "static/media/T14-Photoshop.24b4fdfa.svg";